import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import CrownIcon from 'assets/icons/vip-crown-icon-small.svg';

import classes from './ExpertCoachingCta.module.scss';

/**
 * Shown only for experts with has_career_coaching. The CTA is login-gated the
 * same way the footer's "Schedule Career Coaching" link is.
 */
const ExpertCoachingCta = () => {
	return (
		<div className={classes['coaching']}>
			<h2 className={classes['title']}>Personalized Coaching for Your Professional Growth</h2>

			<p className={classes['included']}>
				<CrownIcon />
				Included in Pharmuni Pro plan
			</p>

			<LinkButton
				className={classes['cta']}
				to='/login?next=/vip-consultation'
				kind='primary-color'>
				Schedule Your Coaching Session
			</LinkButton>
		</div>
	);
};

export default ExpertCoachingCta;
